var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activeAction)?_c('v-layout',{staticClass:"home-footer-info",staticStyle:{"flex":"none"},attrs:{"id":"current-action"}},[_c('span',{staticStyle:{"padding-left":"1px","text-transform":"uppercase"}},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.activeAction))+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3db514c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Footer/ActiveAction.vue
// module id = null
// module chunks = 